import { render, staticRenderFns } from "./GetValue.vue?vue&type=template&id=635138d4&scoped=true"
import script from "./GetValue.vue?vue&type=script&lang=js"
export * from "./GetValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635138d4",
  null
  
)

export default component.exports